var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandScalePinch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes pressIn {\n      0%, 4% { opacity: 1; }\n      8% { opacity: 1; }\n      52% { opacity: 1; }\n      56% { opacity: 1; }\n      100% { opacity: 1; }\n    }\n    @keyframes spread1 {\n      0%, 8% { transform: translate(0,0); }\n      35% { transform: translate(-22px, 22px); }\n      52% { transform: translate(0,0); }\n      58%, 100% { transform: translate(0,0); }\n    }\n    @keyframes spread2 {\n      0%, 8% { transform: translate(0,0); }\n      35% { transform: translate(22px, -22px); }\n      52% { transform: translate(0,0); }\n      58%, 100% { transform: translate(0,0); }\n    }\n    @keyframes dotFade {\n      0%, 4% { opacity: 0; }\n      6% { opacity: 1; }\n      52% { opacity: 1; }\n      54% { opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes ringGrow1 {\n      0%, 6% { r: 8; opacity: 0; }\n      14% { r: 8; opacity: 0.4; }\n      52% { r: 16; opacity: 0.2; }\n      58% { r: 20; opacity: 0; }\n      100% { r: 20; opacity: 0; }\n    }\n    .hand { animation: pressIn 3.5s ease-in-out infinite; }\n    .d1 { animation: spread1 3.5s ease-in-out infinite; }\n    .d2 { animation: spread2 3.5s ease-in-out infinite; }\n    .dot { animation: dotFade 3.5s ease-in-out infinite; }\n    .rng { animation: ringGrow1 3.5s ease-in-out infinite; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hand",
    transform: "translate(55, 65) scale(0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    stroke: "#eee",
    strokeWidth: 2,
    d: "M681.9,925c139,0,312.9-87.6,312.9-297.8s-50.9-308.9-127.5-308.9-31.4,11.5-23.9,27.9l11.5,25.2c6.2,13.7-11.5,21.2-18.1,8.4l-19.5-36.7c-29.2-55.3-67.7-64.2-96-46.5-11.1,7.1-15,19-8.9,30.5,13.3,22.6,23.5,44.3,31.9,62.8,6.2,13.7-11.5,21.2-18.1,8.4-9.3-18.6-22.6-43.4-36.3-58.9-44.3-53.1-119.5-76.6-200-51.8l-116.8,35.8c-77.4,23.9-38.5,119.9,26.6,107.1l113.7-22.1c30.1-5.8,53.6,1.3,65.9,18.1,24.3,31,54.4,84.5,54.4,119.5s-26.6,105.3-86.7,105.3-64.2-10.2-108.4-51.8l-72.1-67.7c-54.4-51.3-142.1,12.4-82.8,85l121.7,149.1c92.1,112.4,184.5,158.9,276.6,158.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "d1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rng",
    cx: 70,
    cy: 120,
    r: 13,
    fill: "none",
    stroke: "#888",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 70,
    cy: 120,
    r: 10,
    fill: "#999"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "d2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "rng",
    cx: 120,
    cy: 80,
    r: 13,
    fill: "none",
    stroke: "#888",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 120,
    cy: 80,
    r: 10,
    fill: "#999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandScalePinch);
export default __webpack_public_path__ + "static/media/hand-scale-pinch.65c03554b1764985a9a05da375e53f00.svg";
export { ForwardRef as ReactComponent };